import React from 'react';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import FormProblemas from "./FormProblemas";

import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';

const URL_LOAD = WS.perfil.load;
const URL_UPDATE = WS.perfil.update;

export default class PageDados extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      nome: '',
      email: '',
      cpf_cnpj: '',
      data_nascimento: '',
      telefone: '',
      strings: STRINGS[window.LANGUAGE],
      loaded: true,
      problemas:[]
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getItemSelect(__args__) {
    const check = __args__.value;
    let resp;
    const arr = __args__.arr;
    arr.map((value,i)=>{
      if(value.value === check){
        resp = arr[i];
        return false;
      }
    });
    return resp;
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    /*Requisitions({
      url: URL_LOAD,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            ...data.data,
            loaded: true
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });*/
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const {
      atencao,
      manNotAllowd
    }
    = this.state.strings;

    /*if(target.name==='sexo' && target.value === 'M')
    {
      var msg = {
        title: atencao,
        text: manNotAllowd
      };

      Dialog.create(msg);

      return false;
    }*/

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const data = {...this.state};

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar,
      periodoGratuitoMsg
    }
    = this.state.strings;

    const form = event.target;

    const cpf_cnpj = form.querySelectorAll("[name='cpf_cnpj']")[0].value;
    const sexo = this.state.sexo;
    const nome = form.querySelectorAll("[name='nome']")[0].value;
    const email = form.querySelectorAll("[name='email']")[0].value;
    const data_nascimento = form.querySelectorAll("[name='data_nascimento']")[0].value;
    const telefone = form.querySelectorAll("[name='telefone']")[0].value;

    const formData = {
      cpf_cnpj,
      sexo,
      foto: this.state.foto,
      nome,
      email,
      data_nascimento,
      telefone,
      problemas: this.state.problemas
    };

    if(!nome &&
      !email &&
      !data_nascimento &&
      !telefone){
      var msg = {
        title: atencao,
        text: preenchaCamposAsterisco
      };

      Dialog.create(msg);
      return false;
    }else{
      var msg = {
        title: atencao,
        text: periodoGratuitoMsg
      };
      Dialog.create(msg);
      /*Requisitions({
        url: URL_UPDATE,
        data: formData,
        sucess:function(data){
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });*/
    }
  }

  getProblemasView() {
    return (
      <FormProblemas
        changeProblemas={(problemas) => this.setState({problemas})}
        problemas={this.state.problemas}
      />
    );
  }

  render(){
    const strings = this.state.strings;
    const problemas = this.state.loaded ? this.getProblemasView() : null;

    return(
      <div>
          <form className="form-login"  onSubmit={this.handleSubmit}>
            <div className='pure-g'>
              <div className='pure-u-1'>
                <TextInput
                  value={this.state.cpf_cnpj}
                  onChange={this.handleInputChange}
                  readOnly
                  name='cpf_cnpj'
                  title={`${strings.txtCpf}`}
                  placeholder=''>
                </TextInput>
              </div>
              <div className='box-sexo-title pure-u-1 hide'>
                <div className='box-title'>
                  <span className=''>{strings.sexo}</span>
                </div>
                <div className="pure-u-1-2 problema-item">
                  <input
                    value="F"
                    name="sexo"
                    type="radio"
                    checked={this.state.sexo==='F'}
                    onChange={this.handleInputChange}
                  />
                <span className='type-pay-txt'>{strings.feminino}</span>
                </div>
                <div className="pure-u-1-2 problema-item ">
                  <input
                    name="sexo"
                    value="M"
                    type="radio"
                    checked={this.state.sexo==='M'}
                    onChange={this.handleInputChange}
                  />
                <span className='type-pay-txt'>{strings.masculino}</span>
                </div>
              </div>
              <div className='pure-u-1 pure-u-md-1-2'>
                <TextInput
                  value={this.state.nome}
                  onChange={this.handleInputChange}
                  name="nome"
                  title={`${strings.txtNome}*`}
                  placeholder={strings.digiteAqui}>
                </TextInput>
              </div>

              <div className='pure-u-1 pure-u-md-1-2'>
                <TextInput
                  value={this.state.email}
                  onChange={this.handleInputChange}
                  name="email"
                  title={`${strings.txtEmailCadastro}*`}
                  placeholder={strings.digiteAqui}>
                </TextInput>
              </div>


              {/*
                <TextInput
                  readOnly
                  value={this.state.cpf}
                  inputMask={{
                    name:'cpf',
                    placeholder: strings.digiteAqui,
                    mask: "999.999.999-99",
                    maskChar: "_"
                  }}
                  onChange={this.handleInputChange}
                  name="cpf"
                  title={`${strings.txtCpf}*`}
                  placeholder={strings.digiteAqui}>
                </TextInput>
              */}
              <div className='pure-u-1 pure-u-md-1-2'>
                <TextInput
                  value={this.state.data_nascimento}
                  inputMask={{
                    name:'data_nascimento',
                    placeholder: strings.digiteAqui,
                    mask: "99/99/9999",
                    maskChar: "_"
                  }}
                  onChange={this.handleInputChange}
                  name="data_nascimento"
                  title={`${strings.txtDataNasc}*`}
                  placeholder={strings.digiteAqui}>
                </TextInput>
              </div>

              <div className='pure-u-1 pure-u-md-1-2'>
                <TextInput
                  value={this.state.telefone}
                  inputMask={{
                    name:'telefone',
                    placeholder: strings.digiteAqui,
                    mask: "(99) 9999-9999",
                    maskChar: "_"
                  }}
                  onChange={this.handleInputChange}
                  name="telefone"
                  title={`${strings.txtTel}*`}
                  placeholder={strings.digiteAqui}>
                </TextInput>
              </div>
            </div>


            {problemas}
            <div className='pure-u-1'>
              <Button
                text={strings.txtSalvar}
                type='submit'
                classes="button-login simple-button"
              />
            </div>
          </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/perfil/PageDados.js